import { render, staticRenderFns } from "./EventDetailsHome.vue?vue&type=template&id=32177f0d&scoped=true"
import script from "./EventDetailsHome.vue?vue&type=script&lang=js"
export * from "./EventDetailsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32177f0d",
  null
  
)

export default component.exports